import { render } from "./QuickApplySidebar.vue?vue&type=template&id=1782bffa"
import script from "./QuickApplySidebar.vue?vue&type=script&lang=js"
export * from "./QuickApplySidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__